module.exports = __webpack_public_path__ + "assets/ninja-forms.4ec95740.svg";